interface FandomIdSource {
  fandom?: { id?: number | string } | number | string | null;
  fandomId?: number | string;
  fandom_id?: number | string;
}

const resolveFandomValue = (fandom: FandomIdSource['fandom']): number | string | undefined => {
  if (fandom == null) {
    return undefined;
  }

  if (typeof fandom === 'object') {
    return fandom.id;
  }

  return fandom;
};

export const resolveNestedFandomId = (source: FandomIdSource): string | undefined => {
  const nestedFandomId = resolveFandomValue(source.fandom) ?? source.fandomId ?? source.fandom_id;
  if (nestedFandomId == null || nestedFandomId === '') {
    return undefined;
  }

  return String(nestedFandomId);
};
